import { Component } from '../../scripts/component';

class RichColumns extends Component {

  connectedCallback() {
    super.connectedCallback();
  }

  clickColumn(event) {
    const url = event.target.getAttribute('data-column-link');
    if (url) window.location.href = url;
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

}

if (!customElements.get('rich-columns')) {
  customElements.define('rich-columns', RichColumns);
}